import Router from 'vue-router';
import { compose } from '@/utils';

const defaultLocationInterceptor = location => {
  if(typeof location === 'string') {
    return { path: location };
  }
  return location;
}

export default class OPCRouter extends Router {
  interceptors = [defaultLocationInterceptor];
  addInterceptor(fn) {
    return this.interceptors.push(fn) - 1;
  }
  removeInterceptor(id) {
    this.interceptors[id] = null;
  }
  push(location) {
    const nextLocation = compose(this.interceptors.filter(Boolean))(location);
    return super.push(nextLocation);
  }
  replace(location) {
    const nextLocation = compose(this.interceptors.filter(Boolean))(location);
    return super.replace(nextLocation);
  }
}
